import React from 'react';
import { withRouter } from 'react-router-dom';
import allPaths from '../../route/allPaths';

const AccessDeniedPage = (props) => {

  const pushURL = () => {
    const { history } = props;
    history.push(allPaths.HOME_ROUTE)
  }

  return (
    <div className='w-100 h-100 d-flex align-items-center justify-content-center justify-content-center'>
      <div className='card p-3'>
        <div className='m-2'>Sorry, you don't have permission to view this page</div>
        <button onClick={pushURL} className="btn btn-outline-primary mt-3">Click to Dashboard</button>
      </div>
    </div>
  )
}

export default withRouter(AccessDeniedPage);
